export const computeSubtotal = ({ pricePerUnit, quantity, pricePrecision }) => {
  const raw = (Number(pricePerUnit) || 0) * (Number(quantity) || 0)
  const divisor = pricePrecision === "hundredths_of_cents" ? 100 : 1
  return Math.round(raw / divisor)
}
